import {
  Box,
  ComponentWithAs,
  IconButtonProps,
  IconProps,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import { KbdNavigation } from "admin/components/common/KbdNavigation";
import { ToolButton } from "../ToolButton";

export interface FooterMenuProps
  extends Omit<IconButtonProps, "icon" | "content" | "aria-label"> {
  icon: ComponentWithAs<"svg", IconProps>;
  label: string;
  notificationCount?: number;
  content: ReactNode;
}

export const FooterMenu = ({
  icon: Icon,
  label,
  content,
  notificationCount = 0,
  ...rest
}: FooterMenuProps) => {
  return (
    <Popover
      isOpen={notificationCount === 0 ? false : undefined}
      placement="bottom-end"
      returnFocusOnClose={false}
    >
      <PopoverTrigger>
        <Box position="relative">
          <ToolButton
            icon={Icon}
            label={label}
            count={notificationCount ? notificationCount : undefined}
            buttonProps={rest}
          />
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent w="500px" maxW="calc(100vw - 48px)">
          <PopoverBody p={6} bg="white">
            {content}
            <KbdNavigation mt={4} />
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
